import React, {Component} from 'react';
import { Icon } from 'antd';
import OtherTable from '../common/otherTable';
import Title from '../common/title';
import {createTimeStr} from "../../../../utils/common";

class InterviewInfo extends Component {
  state = {
    isShowTable: false
  }

  render() {
    const { isShowTable } = this.state;
    const { i18n, userInfo, paperInfo, reportStatus, themeColor } = this.props;
    const columns = [{
      title: `${i18n.result.videoTime}（${userInfo && createTimeStr(userInfo.totalFileDuration)}）`,
      dataIndex: 'videoTime',
      key: 'videoTime',
      align: 'center',
      render: (text, record) => <React.Fragment>
        {record.startTimeStr}<br/>~<br/>{record.endTimeStr}
      </React.Fragment>
    }, {
      title: i18n.result.postName,
      dataIndex: i18n.lang === 'en_us' ? 'postNameEn' : 'postName',
      key: 'postName',
      align: 'center',
      ellipsis: true
    }, {
      title: i18n.result.paperName,
      dataIndex: 'paperName',
      key: 'paperName',
      align: 'center',
      ellipsis: true
    }, {
      title: i18n.result.videoResource,
      dataIndex: i18n.lang === 'en_us' ? 'videoResourceEn' : 'videoResource',
      key: 'videoResource',
      align: 'center'
    }, {
      title: i18n.result.submitStatus,
      dataIndex: i18n.lang === 'en_us' ? 'submitStatusDescEn' : 'submitStatusDesc',
      key: 'submitStatusDesc'
    }, {
      title: i18n.result.finishTimes,
      dataIndex: 'finishTime',
      key: 'finishTime',
      align: 'center',
      ellipsis: true
    }, {
      title: i18n.result.recordStatus,
      dataIndex: i18n.lang === 'en_us' ? 'statusDescEn' : 'statusDesc',
      key: 'statusDesc',
      align: 'center'
    }];
    const dataSource = [{key: 0, ...userInfo, paperName: i18n.lang === 'en_us' ? paperInfo.paperNameEn : paperInfo.paperName}];
    return (
      <div className="interviewInfo">
        <Title iconfont="icon-gerenxinxi">
          {{
            title: i18n.result.interviewTitle,
            content: reportStatus === 2 && <span className="showBtn" onClick={() => this.setState({isShowTable: !isShowTable})} style={{color: themeColor}}><Icon type={isShowTable ? 'down' : 'up'} />{isShowTable ? i18n.result.downText : i18n.result.upText}</span>
          }}
        </Title>
        {((reportStatus === 2 && isShowTable) || reportStatus !== 2) && <div className="pad60 padt16">
          <OtherTable columns={columns} dataSource={dataSource} />
        </div>}
      </div>
    );
  }
}

export default InterviewInfo;
